import { ShowIf } from '@apply/components';
import { useExperienceStillOwn } from '../../../fields/ExperienceFields';
import { CurrentlyOwnProperty } from './components/CurrentlyOwnProperty';
import { DateSold } from './components/DateSold/DateSold';
import { SalesPrice } from './components/SalesPrice';

interface CurrentlyOwnPanelProps {
    experienceId: string | undefined;
}

export const CurrentlyOwnPanel: React.FC<CurrentlyOwnPanelProps> = ({ experienceId }) => {
    const [currentlyOwnProperty] = useExperienceStillOwn(experienceId);
    return (
        <>
            <CurrentlyOwnProperty
                experienceId={experienceId}
                required={false}
            />
            <ShowIf showIf={currentlyOwnProperty == false}>
                <DateSold
                    experienceId={experienceId}
                    required={false}
                />
                <SalesPrice
                    experienceId={experienceId}
                    required={false}
                />
            </ShowIf>
        </>
    );
};
